import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ActivarCuentaPage } from '@/pages/activar-cuenta';

const activarSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/_public/activar')({
  validateSearch: activarSearchSchema,
  component: ActivarCuentaPage,
});
